import * as rxjs from "rxjs";
import AppState from "../models/AppState";
import { delayed } from "../../methods";
import StorylineState from "../models/StorylineState";
import { API } from "../handler/ApiHandler";
import $events from './EventBloc';
import React from "react";
import $ from 'jquery';

class AppBloc {
    constructor() {
        this.currentState = new AppState();
        this.stateSubject = new rxjs.BehaviorSubject(this.currentState);
        this.roomRef      = React.createRef();

        this.registerEvents();

        API.getAppData()
           .then(response => {
               console.log("GOT RESPONSE");
               this.currentState.storylines = response.storylines;
               this.preloadRoomImages();
           })
           .then(() => this.pushState());
    }

    registerEvents = () => {
        $events.$on('app/enterStartRoom', () => {

        });

        $events.$on('tutorial/start', () => {
            this.currentState.storylineState.roomState.bottomModalState.close();
            this.pushState();
        });
    };

    preloadRoomImages = () => {
        this.currentState.storylines.forEach(( storyline ) => {
            let storyState = new StorylineState(storyline)
            storyState.rooms?.forEach(( room ) => {
                console.log(room.thumbnailUrl)
                let $img = $('<img/>');
                $img.attr('src', room.thumbnailUrl);
                $('.preload-container').append($img);
            });
        });
    };

    showHouse = () => {
        this.currentState.houseOpen = true;
        this.pushState();
    };

    getSubject = () => this.stateSubject;

    showStorylineSelect() {
        this.currentState.homeState.storylineSelectOpen = true;
        this.pushState();
    }

    async selectStoryLine( storyline ) {

        this.currentState.houseOpen = true;
        this.pushState();

        await delayed(800);

        this.currentState.storylineState = new StorylineState(storyline);
        this.currentState.storylineState.start();
        this.pushState();

        await delayed(500);

        this.currentState.homeState.storylineSelectOpen = false;
        this.pushState();
    }

    pushState( newState = this.currentState ) {
        let state = newState ?? this.currentState;
        this.stateSubject.next(state);
    }
}

export default AppBloc;
